import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as boxActions from 'redux/modules/box';
import { withDone } from 'react-router-server';
import CBox from '../components/Box'
import { NotFound, Loading, NotOpen } from 'pages';

import cssVars from 'css-vars-ponyfill';
import { fetchStatus } from '../type/config-status';
import PropTypes from 'prop-types'; 


class DBox extends Component {

    static propTypes = {
        box : PropTypes.shape({
            type : PropTypes.string,
            getParam : PropTypes.string,
            payUrl: PropTypes.string,
            selectTab: PropTypes.oneOf([0, 1]),
            selectDonationType: PropTypes.oneOf(["pledge", "oneoff"]),
            brictoworksGoogleTagManager : PropTypes.bool,
            googleTagManager : PropTypes.string,
            ga4TrackingId : PropTypes.string,
            googleAnalytics : PropTypes.string,
            isCrossDomainTrack : PropTypes.bool,
            crossDomainTrack : PropTypes.array,
            data: PropTypes.shape({
                logoImgUrl: PropTypes.string,
                logoUrl: PropTypes.string,
                tenantCode: PropTypes.string,
                tenantName: PropTypes.string,
                boxStatus: PropTypes.number,
                content: PropTypes.shape({
                    title: PropTypes.string,
                    tagList: PropTypes.array,
                    mainImgUrl: PropTypes.string,
                    isYoutubeUrl: PropTypes.bool,
                    youtubeUrl: PropTypes.string,
                    tabMenu: PropTypes.array,
                    tabMenuClass: PropTypes.array,
                    organ: PropTypes.shape({
                        isOpen: PropTypes.bool,
                        name: PropTypes.string,
                        info: PropTypes.string
                    }),
                    content0: PropTypes.string,
                    content1: PropTypes.string,
                    donation: PropTypes.shape({
                        usePledge: PropTypes.bool,
                        useOneOff: PropTypes.bool,
                        payButtonText: PropTypes.string,
                        pledge:
                        PropTypes.shape({
                            donationProgressType: PropTypes.number,
                            title: PropTypes.string,
                            percent: PropTypes.number,
                            monthlyPayPrice: PropTypes.number,
                            memberCount: PropTypes.number
                        }),
                        oneOff:
                        PropTypes.shape({
                            donationProgressType: PropTypes.number,
                            title: PropTypes.string,
                            percent: PropTypes.number,
                            payPrice: PropTypes.number,
                            memberCount: PropTypes.number
                        }),
                    }),
                    footer:
                    PropTypes.shape({
                        title: PropTypes.string,
                        footerlogoImgUrl: PropTypes.string
                    }),
                    mainColor: PropTypes.string,
                    mainFontColor: PropTypes.string,
                    subColor: PropTypes.string,
                    subFontColor: PropTypes.string
                }),
                meta: PropTypes.objectOf(PropTypes.string),
            })     
        })
    };
    
    constructor(props){
        super(props);
    }

    componentWillMount() {
        // 서버사이드에서도 데이터 로딩이 작동하기 위해서, 데이터 불러오는 작업을 componentWillMount 에서 호출합니다.
        const { BoxActions, done } = this.props;

        if(this.props.box.fetchStatus === "") {
            BoxActions.getBox(this.props.match.params.tenantCode, this.props.match.params.boxCode, this.props.location.search).then(done, done); // Promise 가 성공했을때, 혹은 실패했을때 done() 호출
        }  
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.box.fetchStatus === fetchStatus.OpenSuccess) {
            if (this.props.box.data) {
                if (this.props.box.data.content.title === nextProps.box.data.content.title)
                    return false;
                else
                    return true;
            } 
        }
        return true; 
    }
    
    
    render() {     
        function renderView(param) {
            switch (param.fetchStatus) {
                case fetchStatus.Loading : return <Loading />;
                case fetchStatus.Fail: return <NotFound />;
                case fetchStatus.NotOpenSuccess: return <NotOpen isRedirectUrl={param.isRedirectUrl} redirectUrl={param.redirectUrl}/>;
                case fetchStatus.OpenSuccess: return <CBox 
                data={param.data} selectTab={param.selectTab} 
                selectDonationType={param.selectDonationType} payUrl={param.payUrl}
                brictoworksGoogleTagManager={param.brictoworksGoogleTagManager}
                googleTagManager={param.googleTagManager}
                ga4TrackingId={param.ga4TrackingId}
                googleAnalytics={param.googleAnalytics}
                isCrossDomainTrack={param.isCrossDomainTrack}
                crossDomainTrack={param.crossDomainTrack}/>;
            }
        }
        return (
            <div>
                {renderView(this.props.box)}
            </div>
        );
    }
}

function mapReduxStateToReactProps(state) {
    if (state.box.fetchStatus === fetchStatus.OpenSuccess) {
        cssVars({
            variables: {
                '--main-color': state.box.data.content.mainColor,
                '--sub-color': state.box.data.content.subColor,
                '--main-font': state.box.data.content.mainFontColor,
                '--sub-font': state.box.data.content.subFontColor
            }
        });
    } 
    return state;
}

// withDone 으로 감싸주면, done 이 호출될때까지 렌더링을 미룹니다
export default withDone(connect(
    mapReduxStateToReactProps,
    (dispatch) => ({
        BoxActions: bindActionCreators(boxActions, dispatch)
    })
)(DBox));


// WEBPACK FOOTER //
// ./src/pages/DBox.js